import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdc8ceb2&scoped=true"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"
import style0 from "./index.css?vue&type=style&index=0&id=fdc8ceb2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc8ceb2",
  null
  
)

export default component.exports